module.exports = __webpack_public_path__ + "static/media/xuanzhe.cc800593.png";